export default __webpack_public_path__ + "static/1567931330455-3272865d1c06cd488e25c6e23b5dd9a6.jpeg";